// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"WithdrawForm_modalContent__j52lw","totalContent":"WithdrawForm_totalContent__0CVwa"};